<template>
	<div class="xuqiuSqCBox">
		<crumbs bTxt="返回列表" style="width: auto" width="auto" height="60px" hdType="1" @lookBtn="lookBtn" :crumFlag="true" />
		<h1>{{ decData.title }}</h1>
		<!-- <span>申请时间：{{ decData.createTime }}</span> -->
		<p>{{ decData.content }}</p>
		<span v-if="decData.recoverTime">回复时间：{{ decData.recoverTime | momentYR('YYYY年MM月DD日') }}</span>
		<p v-html="decData.recoverContent"></p>
		<h2 v-if="decData.resourceFileId">
			附件：
			<span v-if="decData.effectiveTime">
				{{ syTime }}
			</span>
		</h2>
		<div class="fjBox" v-if="decData.resourceFileId && syTime != '已失效'">
			<img :src="$imgFn(decData.resourceFileName, 1)" alt="" />
			<p>{{ decData.resourceFileName }}</p>
			<h3 @click="xznr(decData.resourceFileId)">下载</h3>
		</div>
	</div>
</template>

<script>
import crumbs from '@/components/hearder/crumbs';

export default {
	name: 'xuqiuSqC',
	data() {
		return {
			a: ['返回']
		};
	},
	props: ['decData'],
	computed: {
		syTime() {
			if (this.decData.effectiveTime - new Date().getTime() > 0) {
				let diff = this.decData.effectiveTime - new Date().getTime();
				const days = Math.floor(diff / (1000 * 60 * 60 * 24));
				const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((diff % (1000 * 60)) / 1000);
				return `（有效时间：${days}天${hours}时${minutes}分）`;
			} else {
				return '已失效';
			}
		}
	},
	methods: {
		lookBtn() {
			this.$emit('hdFn', 'xuqiuSqB');
		},
		xznr(id) {
			this.$xzFn(
				{
					fileId: id,
					clientType: 1
				},
				(res) => {}
			);
		}
	},
	components: {
		crumbs
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.xuqiuSqCBox {
	flex: 1;
	padding: 0 27px 30px;

	h1 {
		font-size: 18px;
		color: #000000;
		margin-bottom: 11px;
		font-weight: bold;
	}
	> span {
		font-size: 12px;
		color: #8f9190;
	}
	p {
		margin-top: 53px;
		font-size: 16px;
		color: #000000;
		line-height: 1.5;
		margin-bottom: 76px;
	}
	h2 {
		font-size: 16px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 19px;
		span {
			color: #f81f1f;
			font-size: 14px;
			font-weight: 400;
		}
	}
	.fjBox {
		display: flex;
		height: 43px;
		background: #f9f9f9;
		border-radius: 4px;
		align-items: center;
		padding: 0 11px 0 10px;
		align-items: center;
		width: 389px;
		box-sizing: border-box;
		img {
			width: 23px;
			height: 27px;
			margin-right: 5px;
		}
		p {
			flex: 1;
			font-size: 14px;
			color: #000;
			margin: 0;
		}
		h3 {
			font-size: 14px;
			color: #1d7b3a;
			cursor: pointer;
		}
	}
}
</style>
